// VEF: Override shopping_cart.place_order on /cart page
// Shows a Frappe Dialog with Table field when stock is insufficient

frappe.ready(function () {
	if (window.location.pathname !== "/cart") return;

	frappe.provide("erpnext.e_commerce.shopping_cart");
	var shopping_cart = erpnext.e_commerce.shopping_cart;

	shopping_cart.place_order = function (btn) {
		shopping_cart.freeze();

		frappe.call({
			type: "POST",
			method: "erpnext.e_commerce.shopping_cart.cart.place_order",
			btn: btn,
			callback: function (r) {
				if (r.exc) {
					shopping_cart.unfreeze();
				} else if (r.message && r.message.stock_errors) {
					shopping_cart.unfreeze();
					shopping_cart.show_stock_error_dialog(r.message.stock_errors);
				} else {
					$(btn).hide();
					window.location.href = "/orders/" + encodeURIComponent(r.message);
				}
			},
		}).fail(function () {
			shopping_cart.unfreeze();
		});
	};

	shopping_cart.show_stock_error_dialog = function (stock_errors) {
		const table_data = stock_errors.map((e) => ({
			item: e.item,
			stock: e.stock,
			ordered: e.ordered,
		}));

		const dialog = new frappe.ui.Dialog({
			title: __("Insufficient Stock"),
			fields: [
				{
					fieldname: "stock_table",
					fieldtype: "Table",
					cannot_add_rows: true,
					cannot_delete_rows: true,
					in_place_edit: true,
					data: table_data,
					get_data: () => table_data,
					fields: [
						{
							fieldtype: "Data",
							read_only: 1,
							fieldname: "item",
							label: __("Item"),
							in_list_view: 1,
						},
						{
							fieldtype: "Data",
							read_only: 1,
							fieldname: "stock",
							label: __("Available Stock"),
							in_list_view: 1,
						},
						{
							fieldtype: "Data",
							read_only: 1,
							fieldname: "ordered",
							label: __("Ordered Qty"),
							in_list_view: 1,
						},
					],
				},
			],
			primary_action_label: __("Close"),
			primary_action: function () {
				dialog.hide();
			},
		});

		dialog.show();

		const grid = dialog.fields_dict.stock_table.grid;
		grid.static_rows = true;
		grid.refresh();

		setTimeout(function () {
			dialog.$wrapper.find(".row-check, .row-index").hide();
		}, 100);
	};
});
